import type { BooleanSelectFilterOption } from '../table/filters/types/booleanFilter';
import type { SelectFilterOption } from '../table/filters/types/selectFilter';
import { makeTypeGuardByPropertyValue } from '../types/makeTypeGuardByPropertyValue';

export type OasObjectFilterChild = {
  field: string;
  filter: OasTableColumnFilter;
  title: string;
};

export type OasTableColumnFilterObject = {
  type: 'object';
  children: OasObjectFilterChild[];
};

export const isOasTableColumnFilterObject = makeTypeGuardByPropertyValue<
  OasTableColumnFilter,
  OasTableColumnFilterObject
>()('type', 'object');

export type OasTableColumnFilterSelect = {
  type: 'select';
  multi?: boolean;
  options: SelectFilterOption[];
};

export const isOasTableColumnFilterSelect = makeTypeGuardByPropertyValue<
  OasTableColumnFilter,
  OasTableColumnFilterSelect
>()('type', 'select');

export type OasTableColumnFilterBoolean = {
  type: 'boolean';
  options: BooleanSelectFilterOption[];
};

export const isOasTableColumnFilterBoolean = makeTypeGuardByPropertyValue<
  OasTableColumnFilter,
  OasTableColumnFilterBoolean
>()('type', 'boolean');

export type OasTableColumnFilter =
  // simple filters are just strings
  | 'asn'
  | 'ip'
  | 'labels'
  | 'number'
  | 'routing'
  | 'text'
  | 'uptime'
  | 'boolean'
  | 'routingIpv6'
  | 'ipv6'
  | 'dateTime'
  // types with arguments are described by an object
  | OasTableColumnFilterObject
  | OasTableColumnFilterSelect
  | OasTableColumnFilterBoolean;
